import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from '../../../../../../../../SUVO-CORE-CLIENT-LIB/projects/suvo-core-client-lib/src/lib/shared/services/api/api.service';
import { CommonService } from '../../../../../../../../SUVO-CORE-CLIENT-LIB/projects/suvo-core-client-lib/src/lib/shared/services/common/common.service';
import { SuvoUsersClientLibSettingsService } from '../../../shared/services/suvo-users-client-lib-settings/suvo-users-client-lib-settings.service';
import { IUser } from '../../authentication/interfaces/user.interface';
import { PublicUserModel } from '../models/public-user-model';

@Injectable({ providedIn: 'root' })
export class PublicUsersService extends CommonService<PublicUserModel> {
  userSubject = new BehaviorSubject<IUser>(null);

  constructor(
    apiService: ApiService,
    private settings: SuvoUsersClientLibSettingsService,
    private http: HttpClient,
  ) {
    super(apiService, settings.usersServiceApi, '');
  }

  getAllUsersFromOrganisation(organisationId: string): Promise<PublicUserModel[]> {
    return this.http
      .get<
        PublicUserModel[]
      >(`${this.settings.usersServiceApi}all-users/usersFromOrganisations?organisationId=${organisationId}`)
      .toPromise();
  }
}
